module.exports = __webpack_public_path__ + "img/ventas.f26a3669.svg";